var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vacations-chart layout",
      staticStyle: { "padding-bottom": "50px !important" },
    },
    [
      _c("vacation-modal", {
        ref: "vacationModal",
        attrs: { "can-edit": _vm.canEdit },
        on: { success: _vm.update, remove: _vm.update },
      }),
      _c("remove-vacation-modal", {
        ref: "removeVacationModal",
        on: { remove: _vm.update },
      }),
      _c("div", { staticClass: "layout-header" }, [
        _c("div", { staticClass: "layout-title" }, [
          _vm._v("График отпусков и больничных"),
        ]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button2", {
                attrs: {
                  size: "small",
                  icon: {
                    icon: "bookmark",
                    activeColor: "white",
                  },
                  tooltip: {
                    text: "Добавить в закладки",
                    activeText: "Убрать из закладок",
                  },
                  "active-color": "blue",
                  active: _vm.bookmark,
                },
                on: {
                  click: function ($event) {
                    _vm.bookmark = !_vm.bookmark
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _vm.canEdit
                ? _c("c-button2", {
                    attrs: {
                      responsive: true,
                      size: "small",
                      label: "Добавить отпуск/больничный",
                      color: "primary",
                      icon: { icon: "plus", color: "white" },
                    },
                    on: { click: _vm.addVacation },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "vacations-chart__content" },
        [
          !_vm.inited
            ? _c("Loader", { attrs: { active: !_vm.inited, height: 300 } })
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.inited,
                  expression: "inited",
                },
              ],
            },
            [
              _c("filters", {
                ref: "filters",
                on: {
                  apply: _vm.applyFilters,
                  inited: function ($event) {
                    _vm.filtersInited = true
                  },
                },
              }),
              _c("vacations-chart", {
                ref: "chart",
                attrs: { "can-edit": _vm.canEdit },
                on: {
                  addPeriod: _vm.addPeriod,
                  editPeriod: _vm.editPeriod,
                  inited: function ($event) {
                    _vm.tableInited = true
                  },
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.chartClickHandler.apply(null, arguments)
                  },
                  focus: function ($event) {
                    return _vm.onChartFocus.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }